// src/components/FacilitiesTable.js
import React, { useEffect, useState } from "react";
import { getFacilities } from "../api";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable"; // ✅ import the function directly

function FacilitiesTable() {
  const [facilities, setFacilities] = useState([]);
  const [provinceFilter, setProvinceFilter] = useState("");

  useEffect(() => {
    getFacilities().then(setFacilities);
  }, []);

  // Apply filter
  const filteredFacilities = facilities.filter(f =>
    provinceFilter ? f.province === provinceFilter : true
  );

  // ✅ Export to Excel
  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredFacilities);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Facilities");
    XLSX.writeFile(workbook, "Facilities.xlsx");
  };

  // ✅ Export to PDF
  const exportToPDF = () => {
    const doc = new jsPDF();

    // Optional title
    doc.text("Facilities Report", 14, 10);

    // Use autoTable function
    autoTable(doc, {
      head: [["Name", "District", "Province"]],
      body: filteredFacilities.map(f => [f.name, f.district, f.province]),
      startY: 20,
    });

    doc.save("Facilities.pdf");
  };

  return (
    <div>
      <h2>Facilities</h2>

      {/* Province Filter */}
      <label>
        Filter by Province:{" "}
        <select
          value={provinceFilter}
          onChange={e => setProvinceFilter(e.target.value)}
        >
          <option value="">All Provinces</option>
          <option value="Khyber Pakhtunkhwa">Khyber Pakhtunkhwa</option>
          <option value="Sindh">Sindh</option>
        </select>
      </label>

      {/* Table */}
      <table
        border="1"
        width="100%"
        style={{ marginTop: "10px", borderCollapse: "collapse" }}
      >
        <thead>
          <tr>
            <th>Name</th>
            <th>District</th>
            <th>Province</th>
          </tr>
        </thead>
        <tbody>
          {filteredFacilities.map(f => (
            <tr key={f._id}>
              <td>{f.name}</td>
              <td>{f.district}</td>
              <td>{f.province}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Export buttons */}
      <div style={{ marginTop: "10px" }}>
        <button onClick={exportToExcel}>Export to Excel</button>
        <button onClick={exportToPDF} style={{ marginLeft: "10px" }}>
          Export to PDF
        </button>
      </div>
    </div>
  );
}

export default FacilitiesTable;
